<div class="aplayer-pic" :style="url ? `background-image: url('${url}')`: ''">
  <slot />
</div>



// WEBPACK FOOTER //
// ./src/components/Picture/src/Picture.html